/**
 * 智能客服挂件异步挂载互斥锁
 * @description 防止 mountWidget 在 await 加载脚本期间被并发调用，导致挂出两个悬浮球
 */

export interface SupportWidgetMountLock {
  /**
   * 尝试开始一次挂载。
   * @returns 本次挂载令牌；已有进行中的挂载时返回 null
   */
  begin: () => number | null;
  /** 当前令牌是否仍有效（未被卸载/作废） */
  isCurrent: (token: number) => boolean;
  /** 结束本次挂载（过期令牌不会影响新的进行中挂载） */
  end: (token: number) => void;
  /** 卸载或资格关闭时作废进行中的挂载 */
  invalidate: () => void;
}

/**
 * 创建挂载互斥锁：同一时间只允许一次 in-flight mount
 */
export function createSupportWidgetMountLock(): SupportWidgetMountLock {
  let inFlight = false;
  let generation = 0;

  return {
    begin() {
      if (inFlight) return null;
      inFlight = true;
      generation += 1;
      return generation;
    },
    isCurrent(token: number) {
      return token === generation;
    },
    end(token: number) {
      if (token === generation) {
        inFlight = false;
      }
    },
    invalidate() {
      generation += 1;
      inFlight = false;
    }
  };
}
